// extracted by mini-css-extract-plugin
export default {"share-button-container":"p1VmH","share-button":"eC6nT","whatsapp":"e0UOe"};